<template>
    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="560px" :close-on-click-modal="false"
        @close="handleClose">
        <el-form :model="form" ref="form" label-width="120px" :label-position="labelPosition">
            <el-form-item :label="$t('maintenanceReminder.车牌号')" prop="CarNo"
                :rules="[{ required: true, message: $t('maintenanceReminder.请选择车牌号'), trigger: 'change' }]">
                <el-select v-model="form.CarNo" filterable :placeholder="$t('maintenanceReminder.请选择车牌号')"
                    style="width:100%">
                    <el-option v-for="no in carList" :key="no" :label="no" :value="no"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item :label="$t('maintenanceReminder.重置时间')" prop="ResetTime"
                :rules="[{ required: true, message: $t('maintenanceReminder.请选择重置时间'), trigger: 'change' }]">
                <el-date-picker v-model="form.ResetTime" type="datetime" value-format="yyyy-MM-dd HH:mm:ss"
                    :placeholder="$t('maintenanceReminder.请选择重置时间')" style="width:100%"
                    :picker-options="{ disabledDate: (date) => date > new Date() }"></el-date-picker>
            </el-form-item>
            <el-form-item :label="$t('maintenanceReminder.重置里程')" prop="ResetMileage">
                <el-input :value="mileageText" @input="onMileageInput" type="number"
                    :placeholder="$t('maintenanceReminder.请输入重置里程')" clearable></el-input>
            </el-form-item>
            <el-form-item :label="$t('maintenanceReminder.重置的零部件')" prop="ResetParts"
                :rules="[{ required: true, type: 'array', message: $t('maintenanceReminder.请选择重置的零部件'), trigger: 'change' }]">
                <el-select v-model="form.ResetParts" multiple filterable :placeholder="$t('maintenanceReminder.请选择重置的零部件')"
                    style="width:100%">
                    <el-option v-for="part in partOptions" :key="part.id" :label="part.name" :value="part.name"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item :label="$t('maintenanceReminder.位置信息')" prop="Location">
                <el-input v-model="form.Location" :placeholder="$t('maintenanceReminder.请输入位置信息')" clearable></el-input>
            </el-form-item>
            <el-form-item :label="$t('maintenanceReminder.备注信息')" prop="Remark">
                <el-input v-model="form.Remark" type="textarea" :rows="3"
                    :placeholder="$t('maintenanceReminder.请输入备注信息')"></el-input>
            </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
            <el-button @click="dialogVisible = false">{{ $t('public.cancel') }}</el-button>
            <el-button type="primary" @click="handleSubmit">{{ $t('public.save') }}</el-button>
        </span>
    </el-dialog>
</template>

<script>
import { resetPartOptions, queryCarList } from './mockData'

export default {
    name: 'ResetRecordDialog',
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        // 编辑时的原记录（含 RecordID）；新增时传 { }
        record: {
            type: Object,
            default: () => ({})
        },
        // 从维保提醒页带入的预填信息（CarNo / ResetMileage / ResetParts）
        prefill: {
            type: Object,
            default: () => ({})
        }
    },
    data() {
        return {
            partOptions: resetPartOptions,
            carList: [],
            mileageText: '',
            form: {
                CarNo: '',
                ResetTime: '',
                ResetMileage: 0,
                ResetParts: [],
                Location: '',
                Remark: ''
            }
        }
    },
    computed: {
        dialogVisible: {
            get() {
                return this.visible
            },
            set(val) {
                this.$emit('update:visible', val)
            }
        },
        labelPosition() {
            return this.$store.getters.LanguageId == 1 ? 'right' : 'top'
        },
        dialogTitle() {
            return this.record.RecordID
                ? this.$t('maintenanceReminder.编辑重置记录')
                : this.$t('maintenanceReminder.新增重置记录')
        }
    },
    watch: {
        visible(val) {
            if (val) {
                this.loadCarList().then(() => {
                    this.initForm()
                })
            }
        }
    },
    methods: {
        // 加载车牌号列表（仅加载一次）
        loadCarList() {
            if (this.carList.length) return Promise.resolve()
            return queryCarList().then(res => {
                if (res.code === 200) this.carList = res.data || []
            })
        },
        // 初始化表单：优先填原记录，其次填提醒页带入的预填信息
        initForm() {
            const cfg = (this.record && this.record.RecordID)
                ? {
                    CarNo: this.record.CarNo,
                    ResetTime: this.record.ResetTime,
                    ResetMileage: this.record.ResetMileage,
                    ResetParts: this.toPartsArray(this.record.ResetParts),
                    Location: this.record.Location || '',
                    Remark: this.record.Remark || ''
                }
                : {
                    CarNo: this.prefill.CarNo || '',
                    ResetTime: this.moment().format('YYYY-MM-DD HH:mm:ss'),
                    ResetMileage: this.prefill.ResetMileage || 0,
                    ResetParts: this.toPartsArray(this.prefill.ResetParts),
                    Location: '',
                    Remark: ''
                }
            this.form = cfg
            this.mileageText = (cfg.ResetMileage !== null && cfg.ResetMileage !== undefined && cfg.ResetMileage !== '')
                ? String(cfg.ResetMileage) : ''
        },
        // 重置里程输入过滤：仅保留数字和小数点，且最多一个小数点
        onMileageInput(val) {
            let s = String(val == null ? '' : val).replace(/[^\d.]/g, '')
            const firstDot = s.indexOf('.')
            if (firstDot !== -1) {
                s = s.slice(0, firstDot + 1) + s.slice(firstDot + 1).replace(/\./g, '')
            }
            this.mileageText = s
        },
        // 统一格式化为零部件名称数组（兼容逗号/分号/顿号分隔的字符串）
        toPartsArray(parts) {
            if (Array.isArray(parts)) return parts.slice()
            if (!parts) return []
            return String(parts).split(/[,，;；、]+/).filter(Boolean)
        },
        handleSubmit() {
            const mt = this.mileageText.trim()
            if (mt === '' || mt === '.' || isNaN(Number(mt))) {
                this.$message.warning(this.$t('maintenanceReminder.请输入重置里程'))
                return
            }
            this.form.ResetMileage = Number(mt)
            this.$refs.form.validate(valid => {
                if (!valid) return
                this.$emit('submit', { ...this.form })
            })
        },
        handleClose() {
            this.$refs.form.clearValidate()
        }
    }
}
</script>

<style scoped>
.dialog-footer {
    text-align: right;
}
</style>